import React from 'react';
import styles from './PayFabricHostedForm.module.scss';
import { PayFabricStatuses, getErrorMessage } from './utils/paymentHelpers';

const validOrigin =
  /^https:\/\/www\.payfabric\.com|https:\/\/sandbox\.payfabric\.com/;

export default function PayFabricHostedForm(props) {
  const {
    hostedFormUrl,
    handleSaveTransactionCompleted,
    handleTransactionCompleted,
    handleTransactionFailed,
    handleWalletCreateCompleted,
    handleWalletUpdateCompleted,
    handleFormLoaded,
    handleCancel,
    handleSubmit,
    classNames,
  } = props;

  const originIsValid = validOrigin.test(hostedFormUrl) || hostedFormUrl === ''; // Allow empty string for loading purposes
  const origin = originIsValid ? validOrigin.exec(hostedFormUrl)?.[0] : '';

  React.useEffect(() => {
    if (!origin) return;

    window.addEventListener('message', handlePayFabricMessage, false);

    return () => {
      window.removeEventListener('message', handlePayFabricMessage, false);
    };

    function handlePayFabricMessage(event) {
      // For best security practice, only accept event message from specified domain.
      if (event.origin !== origin) return;

      //docs: https://github.com/PayFabric/APIs/blob/master/PayFabric/Sections/Objects.md#transaction-response
      const objMsg = JSON.parse(event.data);

      switch (objMsg?.Event) {
        // The OnFormLoaded, OnCancel, and OnTransactionSubmit events are defined in our theme
        // They are not built into the PayFabric service
        case 'OnFormLoaded':
          if (handleFormLoaded instanceof Function) handleFormLoaded();
          return;

        case 'OnCancel':
          if (handleCancel instanceof Function) handleCancel();
          return;

        case 'OnTransactionSubmit':
          if (handleSubmit instanceof Function) handleSubmit();
          return;

        case 'OnSaveTransactionCompleted':
          if (handleSaveTransactionCompleted instanceof Function)
            handleSaveTransactionCompleted(objMsg);
          return;

        case 'OnTransactionCompleted':
          if (
            objMsg.RespStatus === PayFabricStatuses.Approved &&
            handleTransactionCompleted instanceof Function
          ) {
            handleTransactionCompleted(objMsg);
          } else if (handleTransactionFailed instanceof Function) {
            objMsg.errorMessage = getErrorMessage(objMsg.RespStatus);
            handleTransactionFailed(objMsg);
          }
          return;

        case 'OnWalletCreateCompleted':
          if (handleWalletCreateCompleted instanceof Function)
            handleWalletCreateCompleted(objMsg);
          return;

        case 'OnWalletUpdateCompleted':
          if (handleWalletUpdateCompleted instanceof Function)
            handleWalletUpdateCompleted(objMsg);
          return;

        default:
          return;
      }
    }
  }, [
    handleCancel,
    handleFormLoaded,
    handleSaveTransactionCompleted,
    handleSubmit,
    handleTransactionCompleted,
    handleTransactionFailed,
    handleWalletCreateCompleted,
    handleWalletUpdateCompleted,
    origin,
  ]);

  if (!originIsValid) {
    return (
      <p className={styles.error}>
        Cannot display payment form because the form url is invalid
      </p>
    );
  }

  return (
    <div
      className={
        classNames instanceof Array
          ? [styles.container, ...classNames].join(' ')
          : styles.container
      }
    >
      <iframe
        src={hostedFormUrl}
        frameBorder='0'
        title='PayFabric hosted form'
        className={styles.iFrame}
      ></iframe>
    </div>
  );
}
